export default __webpack_public_path__ + "d966bef1a42ed65f4bcdccad4536dd11.png";